import { isReactive, Ref, watch } from "vue"
import { PatchChange, PatchChangeValue } from "./Api"

export function useInstantSave<T extends object>(
    item: Ref<T | undefined>, 
    editItem: T,
    editProperties: Extract<keyof T, string>[],
    saveChanges: (changes: PatchChange[]) => Promise<void>,
    allowSave?: (modItem: T) => boolean) {
  
    if (!isReactive(editItem))
      throw new Error("editItem must be a reactive object")
  
    watch(item, () => {
      if (item.value) {
        for (const key of editProperties) {
          editItem[key] = item.value[key]
        }
      }
    }, { immediate: true })
  
    watch(editItem, async () => {
      if (item.value) {
        if (allowSave && !allowSave(editItem))
          return

        const changes: PatchChange[] = []
        for (const key of editProperties) {
          if (editItem[key] != item.value[key]) {
            changes.push(new PatchChange(`/${key}`, editItem[key] as unknown as PatchChangeValue))
          }
        }
  
        if (changes.length) {
          await saveChanges(changes)
        }
      }
    })
  }
  